/** @type {null | ((to: string, options?: { replace?: boolean; state?: unknown }) => void)} */
let navigateFn = null

/**
 * Register React Router navigate for axios interceptors (avoids circular imports).
 *
 * @param {typeof navigateFn} fn
 */
export function registerAuthNavigate(fn) {
  navigateFn = fn
}

/**
 * @param {string} to
 * @param {{ replace?: boolean, state?: unknown }} [options]
 */
export function authNavigate(to, options) {
  if (typeof navigateFn === 'function') {
    navigateFn(to, options)
  }
}
